<template>
  <div class="view-container">
    <div class="main-layout">
      <div class="left-panel">
        <div class="panel-header">
          <h4>模块目录</h4>
          <div class="panel-header-actions">
            <button @click="openAddTopDialog" class="btn btn-primary btn-xs" title="新增顶级模块"><i class="fas fa-plus"></i> 新增</button>
            <button @click="openImportDialog" class="btn btn-default btn-xs" title="从导航导入"><i class="fas fa-file-import"></i></button>
          </div>
        </div>
        <div class="panel-body">
          <table class="org-table">
            <thead>
              <tr>
                <th>模块名称</th>
                <th width="100">操作</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(node, index) in filteredTree" :key="node.id">
                <tr
                  class="org-row"
                  :class="{ selected: selectedModuleId === node.id }"
                  @click="selectModule(node)"
                >
                  <td>
                    <span class="org-name-cell">
                      <span v-if="node.children && node.children.length > 0"
                            class="expand-icon"
                            :class="{ expanded: expandedIds.includes(node.id) }"
                            @click.stop="toggleExpand(node.id)">
                        <i class="fas fa-caret-right"></i>
                      </span>
                      <span v-else class="expand-placeholder"></span>
                      <i class="fas" :class="node.children && node.children.length > 0 ? 'fa-folder' : 'fa-folder-open'"></i>
                      <span class="org-name">{{ node.name }}</span>
                      <span class="node-badge" v-if="node.children">{{ node.children.length }}</span>
                    </span>
                  </td>
                  <td class="action-cell">
                    <button class="action-btn add" title="添加子模块" @click.stop="openAddChildDialog(node)">
                      <i class="fas fa-plus"></i>
                    </button>
                    <button class="action-btn edit" title="编辑" @click.stop="openEditDialog(node)">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button class="action-btn delete" title="删除" @click.stop="handleDelete(node)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
                <template v-if="node.children && node.children.length > 0 && expandedIds.includes(node.id)">
                  <ModuleRow
                    v-for="(child, childIdx) in node.children"
                    :key="child.id"
                    :node="child"
                    :base-index="index + 1 + getPrevChildCount(filteredTree, index, child)"
                    :depth="1"
                    :selected-id="selectedModuleId"
                    :expanded-ids="expandedIds"
                    @select="selectModule"
                    @edit="openEditDialog"
                    @delete="handleDelete"
                    @add-child="openAddChildDialog"
                    @toggle-expand="toggleExpand"
                  />
                </template>
              </template>
              <tr v-if="filteredTree.length === 0">
                <td colspan="2" class="empty-row">暂无模块，点击上方按钮新建或导入</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="right-panel">
        <div class="panel-body">
          <div v-if="selectedModuleId && selectedModule">
            <div class="right-panel-header">
              <h5>{{ selectedModule.name }} - 子模块列表</h5>
              <button @click="openAddChildDialog(selectedModule)" class="btn btn-primary btn-xs">
                <i class="fas fa-plus"></i> 新增子模块
              </button>
            </div>
            <div v-if="currentChildren.length > 0">
              <table class="member-table">
                <thead>
                  <tr>
                    <th width="40">#</th>
                    <th width="140">模块编码</th>
                    <th>模块名称</th>
                    <th width="60">图标</th>
                    <th width="160">路由路径</th>
                    <th width="60">排序</th>
                    <th width="70">状态</th>
                    <th width="120">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(child, idx) in currentChildren" :key="child.id">
                    <td>{{ idx + 1 }}</td>
                    <td><code class="code-tag">{{ child.code }}</code></td>
                    <td>{{ child.name }}</td>
                    <td><i class="fas" :class="child.icon || 'fa-cube'"></i></td>
                    <td><span class="path-text">{{ child.path || '-' }}</span></td>
                    <td>{{ child.orderNo }}</td>
                    <td><span class="status-badge" :class="child.status === '启用' ? 'enabled' : 'disabled'">{{ child.status }}</span></td>
                    <td class="action-cell">
                      <button @click="openEditDialog(child)" class="action-btn edit" title="编辑"><i class="fas fa-edit"></i></button>
                      <button @click="toggleChildStatus(child)" class="action-btn toggle" title="切换状态"><i class="fas" :class="child.status === '启用' ? 'fa-ban' : 'fa-check'"></i></button>
                      <button @click="handleDelete(child)" class="action-btn delete" title="删除"><i class="fas fa-trash"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="no-members">
              <p>该模块暂无子模块</p>
              <button @click="openAddChildDialog(selectedModule)" class="btn-add-member-sm">
                <i class="fas fa-plus"></i> 添加子模块
              </button>
            </div>
          </div>
          <div v-else class="empty-state">
            <i class="fas fa-sitemap"></i>
            <p>请选择一个模块目录</p>
            <p class="hint">在左侧点击模块名称查看其子模块信息</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showFormModal" class="modal-overlay" @click.self="closeFormModal">
      <div class="modal-dialog">
        <div class="modal-header">
          <h4>{{ formTitle }}</h4>
          <button @click="closeFormModal" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group"><label>模块编码 *</label><input v-model="form.code" type="text" class="form-control" placeholder="如: userManagement"></div>
            <div class="form-group"><label>模块名称 *</label><input v-model="form.name" type="text" class="form-control" placeholder="如: 用户管理"></div>
          </div>
          <div class="form-row">
            <div class="form-group"><label>路由路径</label><input v-model="form.path" type="text" class="form-control" placeholder="如: /user-management"></div>
            <div class="form-group">
              <label>图标</label>
              <div class="input-group">
                <input v-model="form.icon" type="text" class="form-control" placeholder="如: fa-user">
                <button class="btn btn-default" @click="selectIcon">选择</button>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group"><label>排序号</label><input v-model.number="form.orderNo" type="number" class="form-control" placeholder="1"></div>
            <div class="form-group"><label>状态</label><select v-model="form.status" class="form-control"><option value="启用">启用</option><option value="禁用">禁用</option></select></div>
          </div>
          <div class="form-row">
            <div class="form-group"><label v-if="!form.parentId">上级模块</label><label v-else>上级模块（当前父级已锁定）</label><select v-model="form.parentId" class="form-control" :disabled="!!form.parentId && form.id === null"><option :value="0">无（顶级模块）</option><option v-for="m in availableParents" :key="m.id" :value="m.id">{{ m.name }}</option></select></div>
            <div class="form-group"><label>所属菜单组</label><select v-model="form.groupName" class="form-control"><option value="">无</option><option v-for="g in menuGroups" :key="g" :value="g">{{ g }}</option></select></div>
          </div>
          <div class="form-group"><label>备注</label><textarea v-model="form.remark" class="form-control" rows="2" placeholder="备注信息"></textarea></div>
        </div>
        <div class="modal-footer"><button @click="closeFormModal" class="btn btn-default">取消</button><button @click="saveForm" class="btn btn-primary">确认保存</button></div>
      </div>
    </div>

    <div v-if="showImportDialog" class="modal-overlay" @click.self="showImportDialog=false">
      <div class="modal-dialog import-dialog">
        <div class="modal-header"><h4>从导航栏导入模块</h4><button @click="showImportDialog=false" class="modal-close">&times;</button></div>
        <div class="modal-body">
          <p class="import-tip">以下模块将从当前导航栏配置中导入为顶级模块，勾选需要导入的模块：</p>
          <label v-for="item in importableModules" :key="item.code" class="import-checkbox">
            <input type="checkbox" v-model="item.checked"><span>{{ item.name }}</span><span class="import-path">({{ item.path }})</span>
          </label>
        </div>
        <div class="modal-footer"><button @click="showImportDialog=false" class="btn btn-default">取消</button><button @click="doImport" class="btn btn-primary">确认导入</button></div>
      </div>
    </div>

    <!-- 图标选择器 -->
    <div v-if="showIconPicker" class="modal-overlay" @click.self="showIconPicker=false">
      <div class="modal-dialog icon-picker-dialog">
        <div class="modal-header">
          <h4>选择图标</h4>
          <button @click="showIconPicker=false" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <div class="icon-search-box">
            <i class="fas fa-search"></i>
            <input v-model="iconSearch" type="text" class="form-control" placeholder="搜索图标名称...">
          </div>
          <div v-for="group in filteredIcons" :key="group.label" class="icon-group">
            <div class="icon-group-label">{{ group.label }}</div>
            <div class="icon-grid">
              <div
                v-for="icon in group.icons"
                :key="icon"
                class="icon-item"
                :class="{ selected: form.icon === icon }"
                @click="pickIcon(icon)"
                :title="icon"
              >
                <i class="fas" :class="icon"></i>
                <span class="icon-name">{{ icon.replace('fa-', '') }}</span>
              </div>
            </div>
          </div>
          <div v-if="filteredIcons.length === 0" class="no-icons">未找到匹配的图标</div>
        </div>
        <div class="modal-footer">
          <span class="icon-preview" v-if="form.icon">
            <i class="fas" :class="form.icon"></i> {{ form.icon }}
          </span>
          <button @click="showIconPicker=false" class="btn btn-default">取消</button>
          <button @click="showIconPicker=false" class="btn btn-primary">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, defineComponent, h } from 'vue'

const menuGroups = ref(['用户中心', '公告中心', '权限中心', '数据中心', '研发中心', '管理中心', '报表中心', '个人中心', '待办中心', '任务中心'])

const modules = ref([
  { id: 1, code: 'dashboard', name: '首页', path: '/dashboard', icon: 'fa-home', orderNo: 1, status: '启用', parentId: 0, groupName: '', remark: '系统首页', children: [] },
  { id: 2, code: 'userCenter', name: '用户中心', path: '', icon: 'fa-users', orderNo: 2, status: '启用', parentId: 0, groupName: '', remark: '用户管理菜单组', children: [
    { id: 3, code: 'users', name: '用户管理', path: '/users', icon: 'fa-user', orderNo: 1, status: '启用', parentId: 2, groupName: '用户中心', remark: '', children: [] },
    { id: 4, code: 'roles', name: '角色管理', path: '/roles', icon: 'fa-user-tag', orderNo: 2, status: '启用', parentId: 2, groupName: '用户中心', remark: '', children: [] },
    { id: 5, code: 'organizations', name: '组织管理', path: '/organizations', icon: 'fa-building', orderNo: 3, status: '启用', parentId: 2, groupName: '用户中心', remark: '', children: [] }
  ]},
  { id: 6, code: 'devCenter', name: '研发中心', path: '', icon: 'fa-code', orderNo: 3, status: '启用', parentId: 0, groupName: '', remark: '研发管理菜单组', children: [
    { id: 7, code: 'processManagement', name: '流程管理', path: '/process-management', icon: 'fa-sitemap', orderNo: 1, status: '启用', parentId: 6, groupName: '研发中心', remark: '', children: [] },
    { id: 8, code: 'jobManagement', name: '定时作业管理', path: '/job-management', icon: 'fa-clock', orderNo: 2, status: '启用', parentId: 6, groupName: '研发中心', remark: '', children: [] }
  ]},
  { id: 13, code: 'announcementCenter', name: '公告中心', path: '', icon: 'fa-bullhorn', orderNo: 4, status: '启用', parentId: 0, groupName: '', remark: '', children: [
    { id: 14, code: 'announcements', name: '公告管理', path: '/announcements', icon: 'fa-newspaper', orderNo: 1, status: '启用', parentId: 13, groupName: '公告中心', remark: '', children: [] }
  ]},
  { id: 9, code: 'managementCenter', name: '管理中心', path: '', icon: 'fa-cog', orderNo: 5, status: '启用', parentId: 0, groupName: '', remark: '系统管理中心', children: [
    { id: 10, code: 'taskManagement', name: '任务管理', path: '/task-management', icon: 'fa-tasks', orderNo: 1, status: '启用', parentId: 9, groupName: '管理中心', remark: '', children: [] },
    { id: 11, code: 'moduleManagement', name: '模块管理', path: '/module-management', icon: 'fa-th-list', orderNo: 2, status: '启用', parentId: 9, groupName: '管理中心', remark: '', children: [] },
    { id: 12, code: 'systemManagement', name: '系统管理', path: '/system-management', icon: 'fa-sliders-h', orderNo: 3, status: '启用', parentId: 9, groupName: '管理中心', remark: '', children: [] },
    { id: 15, code: 'companyManagement', name: '公司管理', path: '/company-management', icon: 'fa-building', orderNo: 4, status: '启用', parentId: 9, groupName: '管理中心', remark: '', children: [] },
    { id: 16, code: 'tenantManagement', name: '租户管理', path: '/tenant-management', icon: 'fa-cloud', orderNo: 5, status: '启用', parentId: 9, groupName: '管理中心', remark: '', children: [] }
  ]},
  { id: 17, code: 'taskCenter', name: '任务中心', path: '', icon: 'fa-list-alt', orderNo: 6, status: '启用', parentId: 0, groupName: '', remark: '', children: [
    { id: 18, code: 'completedTasks', name: '已处理任务', path: '/completed-tasks', icon: 'fa-check-circle', orderNo: 1, status: '启用', parentId: 17, groupName: '任务中心', remark: '', children: [] },
    { id: 19, code: 'viewableTasks', name: '可查看任务', path: '/viewable-tasks', icon: 'fa-eye', orderNo: 2, status: '启用', parentId: 17, groupName: '任务中心', remark: '', children: [] },
    { id: 20, code: 'submittedTasks', name: '已提交任务', path: '/submitted-tasks', icon: 'fa-paper-plane', orderNo: 3, status: '启用', parentId: 17, groupName: '任务中心', remark: '', children: [] },
    { id: 21, code: 'ccTasks', name: '抄送任务', path: '/cc-tasks', icon: 'fa-copy', orderNo: 4, status: '启用', parentId: 17, groupName: '任务中心', remark: '', children: [] }
  ]},
  { id: 22, code: 'todoCenter', name: '待办中心', path: '', icon: 'fa-clipboard-list', orderNo: 7, status: '启用', parentId: 0, groupName: '', remark: '', children: [
    { id: 23, code: 'pendingTasks', name: '待处理', path: '/pending-tasks', icon: 'fa-hourglass-half', orderNo: 1, status: '启用', parentId: 22, groupName: '待办中心', remark: '', children: [] },
    { id: 24, code: 'launchableProcesses', name: '可发起', path: '/launchable-processes', icon: 'fa-play-circle', orderNo: 2, status: '启用', parentId: 22, groupName: '待办中心', remark: '', children: [] },
    { id: 25, code: 'drafts', name: '草稿箱', path: '/drafts', icon: 'fa-edit', orderNo: 3, status: '启用', parentId: 22, groupName: '待办中心', remark: '', children: [] }
  ]},
  { id: 26, code: 'permissionCenter', name: '权限中心', path: '', icon: 'fa-shield-alt', orderNo: 8, status: '启用', parentId: 0, groupName: '', remark: '', children: [
    { id: 27, code: 'aaPermissions', name: '公告权限', path: '/aa-permissions', icon: 'fa-lock', orderNo: 1, status: '启用', parentId: 26, groupName: '权限中心', remark: '', children: [] },
    { id: 28, code: 'baPermissions', name: '模块权限', path: '/ba-permissions', icon: 'fa-lock', orderNo: 2, status: '启用', parentId: 26, groupName: '权限中心', remark: '', children: [] },
    { id: 29, code: 'laPermissions', name: '流程权限', path: '/la-permissions', icon: 'fa-lock', orderNo: 3, status: '启用', parentId: 26, groupName: '权限中心', remark: '', children: [] },
    { id: 30, code: 'daPermissions', name: '报表权限', path: '/da-permissions', icon: 'fa-lock', orderNo: 4, status: '启用', parentId: 26, groupName: '权限中心', remark: '', children: [] }
  ]},
  { id: 31, code: 'dataCenter', name: '数据中心', path: '', icon: 'fa-database', orderNo: 9, status: '启用', parentId: 0, groupName: '', remark: '', children: [
    { id: 32, code: 'databaseManager', name: '数据库管理', path: '/database-manager', icon: 'fa-server', orderNo: 1, status: '启用', parentId: 31, groupName: '数据中心', remark: '', children: [] },
    { id: 33, code: 'sqlExecution', name: '语句执行', path: '/sql-execution', icon: 'fa-terminal', orderNo: 2, status: '启用', parentId: 31, groupName: '数据中心', remark: '', children: [] },
    { id: 34, code: 'logQuery', name: '日志查询', path: '/log-query', icon: 'fa-file-alt', orderNo: 3, status: '启用', parentId: 31, groupName: '数据中心', remark: '', children: [] }
  ]},
  { id: 35, code: 'reportCenter', name: '报表中心', path: '', icon: 'fa-chart-bar', orderNo: 10, status: '启用', parentId: 0, groupName: '', remark: '', children: [
    { id: 36, code: 'systemReports', name: '系统报表', path: '/system-reports', icon: 'fa-chart-pie', orderNo: 1, status: '启用', parentId: 35, groupName: '报表中心', remark: '', children: [] },
    { id: 37, code: 'customReports', name: '自定义报表', path: '/custom-reports', icon: 'fa-chart-line', orderNo: 2, status: '启用', parentId: 35, groupName: '报表中心', remark: '', children: [] },
    { id: 38, code: 'reportManagement', name: '报表管理', path: '/report-management', icon: 'fa-tasks', orderNo: 3, status: '启用', parentId: 35, groupName: '报表中心', remark: '', children: [] }
  ]},
  { id: 39, code: 'personalCenter', name: '个人中心', path: '', icon: 'fa-user', orderNo: 11, status: '启用', parentId: 0, groupName: '', remark: '', children: [
    { id: 40, code: 'personalInfo', name: '个人信息', path: '/personal-info', icon: 'fa-id-card', orderNo: 1, status: '启用', parentId: 39, groupName: '个人中心', remark: '', children: [] },
    { id: 41, code: 'passwordChange', name: '密码修改', path: '/password-change', icon: 'fa-key', orderNo: 2, status: '启用', parentId: 39, groupName: '个人中心', remark: '', children: [] },
    { id: 42, code: 'proxySettings', name: '代理设置', path: '/proxy-settings', icon: 'fa-user-cog', orderNo: 3, status: '启用', parentId: 39, groupName: '个人中心', remark: '', children: [] },
    { id: 43, code: 'quickLinkManager', name: '快捷入口', path: '/quick-link-manager', icon: 'fa-bolt', orderNo: 4, status: '启用', parentId: 39, groupName: '个人中心', remark: '', children: [] }
  ]}
])

const importableModules = ref([
])

// 图标选择器
const showIconPicker = ref(false)
const iconSearch = ref('')

const iconGroups = [
  { label: '常用', icons: ['fa-home', 'fa-user', 'fa-users', 'fa-cog', 'fa-chart-bar', 'fa-database', 'fa-file-alt', 'fa-envelope', 'fa-bell', 'fa-calendar', 'fa-search', 'fa-plus', 'fa-edit', 'fa-trash', 'fa-check', 'fa-times'] },
  { label: '导航', icons: ['fa-bars', 'fa-th-list', 'fa-sitemap', 'fa-compass', 'fa-map', 'fa-map-marker', 'fa-location-arrow', 'fa-globe', 'fa-server', 'fa-cloud', 'fa-desktop', 'fa-mobile', 'fa-tablet'] },
  { label: '业务', icons: ['fa-tasks', 'fa-clipboard-list', 'fa-list-alt', 'fa-hourglass-half', 'fa-play-circle', 'fa-paper-plane', 'fa-copy', 'fa-check-circle', 'fa-exclamation-circle', 'fa-info-circle', 'fa-question-circle', 'fa-ban', 'fa-lock', 'fa-shield-alt', 'fa-key'] },
  { label: '状态', icons: ['fa-check-circle', 'fa-times-circle', 'fa-exclamation-triangle', 'fa-star', 'fa-heart', 'fa-thumbs-up', 'fa-flag', 'fa-tag', 'fa-bookmark', 'fa-eye', 'fa-eye-slash', 'fa-toggle-on', 'fa-toggle-off'] },
  { label: '文档', icons: ['fa-file', 'fa-folder', 'fa-folder-open', 'fa-file-pdf', 'fa-file-excel', 'fa-file-word', 'fa-file-image', 'fa-file-archive', 'fa-file-code', 'fa-newspaper', 'fa-book', 'fa-clipboard'] },
  { label: '通讯', icons: ['fa-envelope', 'fa-envelope-open', 'fa-inbox', 'fa-paper-plane', 'fa-comment', 'fa-comments', 'fa-phone', 'fa-fax', 'fa-at', 'fa-address-book', 'fa-address-card'] },
  { label: '开发', icons: ['fa-code', 'fa-bug', 'fa-terminal', 'fa-code-branch', 'fa-cube', 'fa-cubes', 'fa-puzzle-piece', 'fa-wrench', 'fa-tools', 'fa-sliders-h', 'fa-filter', 'fa-fire'] },
  { label: '图表', icons: ['fa-chart-bar', 'fa-chart-line', 'fa-chart-pie', 'fa-chart-area', 'fa-table', 'fa-chart-simple'] },
  { label: '用户', icons: ['fa-user', 'fa-users', 'fa-user-plus', 'fa-user-edit', 'fa-user-cog', 'fa-user-tag', 'fa-user-friends', 'fa-id-card', 'fa-id-badge', 'fa-crown', 'fa-user-secret', 'fa-user-astronaut'] },
  { label: '其他', icons: ['fa-clock', 'fa-bolt', 'fa-fire', 'fa-gem', 'fa-gift', 'fa-rocket', 'fa-umbrella', 'fa-shopping-cart', 'fa-truck', 'fa-building', 'fa-industry', 'fa-warehouse', 'fa-cogs', 'fa-hammer', 'fa-magic'] }
]

const filteredIcons = computed(() => {
  if (!iconSearch.value.trim()) return iconGroups
  const kw = iconSearch.value.toLowerCase()
  return iconGroups
    .map(g => ({ label: g.label, icons: g.icons.filter(i => i.replace('fa-', '').includes(kw)) }))
    .filter(g => g.icons.length > 0)
})

function selectIcon() { 
  showIconPicker.value = true 
  iconSearch.value = ''
}

function pickIcon(icon) {
  form.value.icon = icon
}

const selectedModuleId = ref(null)
const showFormModal = ref(false)
const showImportDialog = ref(false)
const expandedIds = ref([1, 2, 6, 9, 13, 17, 22, 26, 31, 35, 39])

const form = ref({ id: null, code: '', name: '', path: '', icon: '', orderNo: 0, status: '启用', parentId: 0, groupName: '', remark: '' })

const formTitle = computed(() => form.value.id ? '编辑模块' : '新增模块')

const selectedModule = computed(() => {
  const find = (list, id) => {
    for (const m of list) {
      if (m.id === id) return m
      if (m.children) {
        const found = find(m.children, id)
        if (found) return found
      }
    }
    return null
  }
  return find(modules.value, selectedModuleId.value)
})

const currentChildren = computed(() => selectedModule.value?.children || [])

const filteredTree = computed(() => modules.value)

const availableParents = computed(() => {
  const excludeId = form.value.id
  const list = []
  const collect = (mods) => {
    mods.forEach(m => {
      if (m.id !== excludeId) list.push({ id: m.id, name: m.name })
      if (m.children) collect(m.children)
    })
  }
  collect(modules.value)
  return list
})

function getPrevChildCount(list, currentIndex, targetChild) {
  let count = 0
  for (let i = 0; i < currentIndex; i++) { count += countAllChildren(list[i]) + 1 }
  const parent = list[currentIndex]
  if (parent.children) {
    const findIdx = (children, target) => { let idx = 0; for (const c of children) { if (c.id === target.id) return idx; idx++ } return -1 }
    const childIdx = findIdx(parent.children, targetChild)
    for (let i = 0; i < childIdx; i++) { count += countAllChildren(parent.children[i]) + 1 }
  }
  return count
}

function countAllChildren(node) {
  let count = 0
  if (node.children) { count += node.children.length; for (const c of node.children) count += countAllChildren(c) }
  return count
}

function toggleExpand(id) {
  const idx = expandedIds.value.indexOf(id)
  if (idx !== -1) expandedIds.value.splice(idx, 1)
  else expandedIds.value.push(id)
}

function selectModule(node) {
  selectedModuleId.value = node.id
}

function openAddTopDialog() {
  form.value = { id: null, code: '', name: '', path: '', icon: '', orderNo: 0, status: '启用', parentId: 0, groupName: '', remark: '' }
  showFormModal.value = true
}

function openAddChildDialog(node) {
  form.value = { id: null, code: '', name: '', path: '', icon: '', orderNo: 0, status: '启用', parentId: node.id, groupName: node.groupName || '', remark: '' }
  showFormModal.value = true
}

function openEditDialog(node) {
  form.value = { ...node }
  showFormModal.value = true
}

function closeFormModal() {
  showFormModal.value = false
  form.value = { id: null, code: '', name: '', path: '', icon: '', orderNo: 0, status: '启用', parentId: 0, groupName: '', remark: '' }
}

function saveForm() {
  if (!form.value.code.trim() || !form.value.name.trim()) { $message.warning('请填写模块编码和名称'); return }
  if (form.value.id) {
    const update = (list) => {
      for (const m of list) {
        if (m.id === form.value.id) {
          Object.assign(m, { ...form.value })
          return true
        }
        if (m.children && update(m.children)) return true
      }
      return false
    }
    update(modules.value)
  } else {
    const newId = Date.now()
    if (form.value.parentId === 0) {
      modules.value.push({ ...form.value, id: newId, children: [] })
    } else {
      const add = (list, parentId) => {
        for (const m of list) {
          if (m.id === parentId) {
            if (!m.children) m.children = []
            m.children.push({ ...form.value, id: newId, children: [] })
            return
          }
          if (m.children) add(m.children, parentId)
        }
      }
      add(modules.value, form.value.parentId)
    }
  }
  closeFormModal()
}

async function handleDelete(node) {
  const hasChildren = node.children && node.children.length > 0
  const msg = hasChildren ? `模块 "${node.name}" 下存在 ${node.children.length} 个子模块，删除后子模块也将一并移除，确定删除吗？` : `确定删除模块 "${node.name}" 吗？`
  if (!await $confirm(msg)) return
  const remove = (list, id) => {
    const idx = list.findIndex(m => m.id === id)
    if (idx !== -1) { list.splice(idx, 1); return true }
    for (const m of list) { if (m.children && remove(m.children, id)) return true }
    return false
  }
  remove(modules.value, node.id)
  if (selectedModuleId.value === node.id) selectedModuleId.value = null
}

function toggleChildStatus(child) {
  child.status = child.status === '启用' ? '禁用' : '启用'
}

function openImportDialog() { showImportDialog.value = true }
function doImport() {
  const selected = importableModules.value.filter(m => m.checked)
  if (selected.length === 0) { $message.warning('请选择要导入的模块'); return }
  selected.forEach(m => {
    if (!findByCode(modules.value, m.code)) {
      modules.value.push({ id: Date.now() + Math.random(), code: m.code, name: m.name, path: m.path, icon: 'fa-cube', orderNo: 99, status: '启用', parentId: 0, groupName: '', remark: '从导航导入', children: [] })
    }
  })
  importableModules.value.forEach(m => m.checked = false)
  showImportDialog.value = false
  $message.success(`成功导入 ${selected.length} 个模块`)
}

function findByCode(list, code) {
  for (const m of list) {
    if (m.code === code) return m
    if (m.children) { const found = findByCode(m.children, code); if (found) return found }
  }
  return null
}

const ModuleRow = defineComponent({
  name: 'ModuleRow',
  props: { node: Object, baseIndex: Number, depth: Number, selectedId: Number, expandedIds: Array },
  emits: ['select', 'edit', 'delete', 'add-child', 'toggle-expand'],
  render() {
    const indent = { paddingLeft: (this.depth * 20 + 8) + 'px' }
    const children = []
    const row = h('tr', {
      class: ['org-row', { selected: this.selectedId === this.node.id }],
      onClick: () => this.$emit('select', this.node)
    }, [
      h('td', { style: indent }, [
        h('span', { class: 'org-name-cell' }, [
          this.node.children && this.node.children.length > 0
            ? h('span', {
                class: ['expand-icon', this.expandedIds.includes(this.node.id) ? 'expanded' : ''],
                onClick: (e) => { e.stopPropagation(); this.$emit('toggle-expand', this.node.id) }
              }, h('i', { class: 'fas fa-caret-right' }))
            : h('span', { class: 'expand-placeholder' }),
          h('i', { class: 'fas', class: this.node.children && this.node.children.length > 0 ? 'fa-folder' : 'fa-folder-open' }),
          h('span', { class: 'org-name' }, this.node.name),
          this.node.children ? h('span', { class: 'node-badge' }, this.node.children.length) : null
        ])
      ]),
      h('td', { class: 'action-cell' }, [
        h('button', { class: 'action-btn add', title: '添加子模块', onClick: (e) => { e.stopPropagation(); this.$emit('add-child', this.node) } }, h('i', { class: 'fas fa-plus' })),
        h('button', { class: 'action-btn edit', title: '编辑', onClick: (e) => { e.stopPropagation(); this.$emit('edit', this.node) } }, h('i', { class: 'fas fa-edit' })),
        h('button', { class: 'action-btn delete', title: '删除', onClick: (e) => { e.stopPropagation(); this.$emit('delete', this.node) } }, h('i', { class: 'fas fa-trash' }))
      ])
    ])
    children.push(row)
    if (this.node.children && this.node.children.length > 0 && this.expandedIds.includes(this.node.id)) {
      let childIdx = this.baseIndex + 1
      this.node.children.forEach(child => {
        const childCount = this.countChild(child)
        children.push(h(ModuleRow, {
          key: child.id, node: child, baseIndex: childIdx, depth: this.depth + 1, selectedId: this.selectedId, expandedIds: this.expandedIds,
          onSelect: (n) => this.$emit('select', n),
          onEdit: (n) => this.$emit('edit', n),
          onDelete: (n) => this.$emit('delete', n),
          onAddChild: (id) => this.$emit('add-child', id),
          onToggleExpand: (id) => this.$emit('toggle-expand', id)
        }))
        childIdx += childCount + 1
      })
    }
    return h('template', children)
  },
  methods: {
    countChild(node) { let c = 0; if (node.children) { c += node.children.length; for (const ch of node.children) c += this.countChild(ch) } return c }
  }
})
</script>

<style scoped>
.view-container { padding: 16px; background: #f5f7fa; }

.main-layout { display: flex; gap: 16px; min-height: calc(94vh - 110px); max-height: calc(94vh - 110px); }

.left-panel { flex: 0 0 22%; background: #fff; border-radius: 6px; border: 1px solid #e8ecf1; overflow: hidden; display: flex; flex-direction: column; }
.panel-header { padding: 10px 12px; border-bottom: 1px solid #e8ecf1; display: flex; justify-content: space-between; align-items: center; background: #fafbfc; }
.panel-header h4 { margin: 0; font-size: 13px; font-weight: 600; color: #374151; }
.panel-header-actions { display: flex; gap: 6px; }
.panel-header-actions .btn-xs { padding: 3px 8px; font-size: 11px; }

.right-panel { flex: 1; background: #fff; border-radius: 6px; border: 1px solid #e8ecf1; overflow: hidden; }
.panel-body { height: 100%; padding: 8px; overflow-y: auto; }

.right-panel-header { padding: 8px 12px; border-bottom: 1px solid #e8ecf1; display: flex; justify-content: space-between; align-items: center; }
.right-panel-header h5 { margin: 0; font-size: 13px; font-weight: 600; color: #374151; }

.org-table { width: 100%; border-collapse: collapse; }
.org-table thead th { padding: 8px 10px; text-align: left; font-size: 11px; font-weight: 600; color: #6b7280; background: #f8fafc; border-bottom: 1px solid #e8ecf1; }
.org-table tbody td { padding: 7px 10px; border-bottom: 1px solid #f3f4f6; font-size: 12px; color: #374151; }

.org-row { cursor: pointer; transition: background 0.1s; }
.org-row:hover { background: #f9fafb; }
.org-row.selected { background: #ecfdf5; }
.org-row.selected td { color: #059669; }

.empty-row { text-align: center; padding: 20px; color: #9ca3af; }

.org-name-cell { display: flex; align-items: center; gap: 4px; }
.expand-icon { width: 14px; height: 14px; display: flex; align-items: center; justify-content: center; color: #9ca3af; font-size: 9px; cursor: pointer; }
.expand-icon:hover { color: #10b981; }
.expand-icon.expanded i { transform: rotate(90deg); }
.expand-placeholder { width: 14px; }
.org-name-cell i { color: #10b981; font-size: 11px; }
.org-name { margin-left: 2px; font-size: 12px; }
.node-badge { margin-left: 4px; background: #ecfdf5; color: #059669; font-size: 10px; padding: 0 5px; border-radius: 8px; min-width: 16px; text-align: center; display: inline-block; line-height: 16px; }

.action-cell { display: flex; gap: 4px; justify-content: flex-end; }
.action-btn { width: 22px; height: 22px; border: 1px solid #e5e7eb; border-radius: 3px; background: #fff; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 10px; transition: all 0.15s; }
.action-btn.add { color: #10b981; border-color: #d1fae5; }
.action-btn.add:hover { background: #10b981; color: #fff; border-color: #10b981; }
.action-btn.edit { color: #6366f1; border-color: #e0e7ff; }
.action-btn.edit:hover { background: #6366f1; color: #fff; border-color: #6366f1; }
.action-btn.delete { color: #ef4444; border-color: #fee2e2; }
.action-btn.delete:hover { background: #ef4444; color: #fff; border-color: #ef4444; }
.action-btn.toggle { color: #f59e0b; border-color: #fef3c7; }
.action-btn.toggle:hover { background: #f59e0b; color: #fff; border-color: #f59e0b; }

.member-table { width: 100%; border-collapse: collapse; }
.member-table thead th { padding: 8px 10px; text-align: left; font-size: 11px; font-weight: 600; color: #6b7280; background: #f8fafc; border-bottom: 1px solid #e8ecf1; white-space: nowrap; }
.member-table tbody td { padding: 8px 10px; border-bottom: 1px solid #f3f4f6; font-size: 12px; color: #374151; }
.member-table tbody tr:hover { background: #f9fafb; }

.code-tag { background: #f0f4ff; color: #6366f1; padding: 1px 6px; border-radius: 3px; font-size: 11px; font-family: 'Consolas','Monaco',monospace; }
.path-text { color: #6b7280; font-size: 11px; font-family: monospace; }
.status-badge { display: inline-block; padding: 2px 8px; border-radius: 3px; font-size: 11px; font-weight: 500; }
.status-badge.enabled { background-color: #dcfce7; color: #16a34a; }
.status-badge.disabled { background-color: #fee2e2; color: #dc2626; }

.no-members { text-align: center; padding: 40px 20px; color: #9ca3af; }
.no-members p { margin-bottom: 12px; font-size: 13px; }
.btn-add-member-sm { padding: 6px 12px; background: #10b981; border: none; border-radius: 4px; color: #fff; font-size: 12px; cursor: pointer; display: inline-flex; align-items: center; gap: 4px; }
.btn-add-member-sm:hover { background: #059669; }

.empty-state { text-align: center; padding: 60px 20px; color: #9ca3af; }
.empty-state i { font-size: 48px; margin-bottom: 12px; color: #d1d5db; }
.empty-state p { font-size: 14px; margin-bottom: 4px; }
.empty-state .hint { font-size: 12px; color: #d1d5db; }

.btn { padding: 6px 14px; border: 1px solid transparent; border-radius: 4px; font-size: 13px; cursor: pointer; transition: all 0.2s; display: inline-flex; align-items: center; gap: 4px; }
.btn-primary { background: #10b981; color: #fff; border-color: #10b981; }
.btn-primary:hover { background: #059669; }
.btn-default { background: #fff; color: #374151; border-color: #d1d5db; }
.btn-default:hover { background: #f9fafb; }
.btn-xs { padding: 3px 8px; font-size: 11px; }

.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-dialog { background: #fff; border-radius: 6px; width: 720px; max-height: 80vh; overflow-y: auto; }
.import-dialog { width: 520px; }
.modal-header { display: flex; justify-content: space-between; align-items: center; padding: 15px 20px; border-bottom: 1px solid #e7eaec; }
.modal-header h4 { margin: 0; font-size: 15px; }
.modal-close { background: none; border: none; font-size: 22px; cursor: pointer; color: #999; }
.modal-close:hover { color: #333; }
.modal-body { padding: 20px; }
.form-row { display: flex; gap: 15px; margin-bottom: 15px; }
.form-group { flex: 1; }
.form-group label { display: block; font-size: 13px; color: #676a6c; margin-bottom: 5px; font-weight: 500; }
.form-group .form-control { width: 100%; padding: 8px 12px; border: 1px solid #e7eaec; border-radius: 4px; font-size: 13px; box-sizing: border-box; }
.form-group textarea.form-control { resize: vertical; }
.input-group { display: flex; gap: 8px; }
.input-group .form-control { flex: 1; }
.modal-footer { padding: 12px 20px; border-top: 1px solid #e7eaec; display: flex; justify-content: flex-end; gap: 10px; }

.import-tip { font-size: 13px; color: #676a6c; margin-bottom: 15px; }
.import-checkbox { display: flex; align-items: center; gap: 10px; padding: 8px 0; border-bottom: 1px solid #f0f0f0; cursor: pointer; font-size: 13px; }
.import-checkbox input[type="checkbox"] { width: 16px; height: 16px; cursor: pointer; }
.import-path { color: #999; font-size: 12px; margin-left: auto; }

/* 图标选择器 */
.icon-picker-dialog { width: 660px; max-height: 75vh; }
.icon-search-box { display: flex; align-items: center; gap: 8px; margin-bottom: 16px; padding: 8px 12px; border: 1px solid #e7eaec; border-radius: 4px; background: #f9fafb; }
.icon-search-box i { color: #9ca3af; font-size: 14px; }
.icon-search-box .form-control { border: none; background: transparent; padding: 0; font-size: 13px; }
.icon-search-box .form-control:focus { outline: none; }
.icon-group { margin-bottom: 14px; }
.icon-group-label { font-size: 12px; font-weight: 600; color: #6b7280; margin-bottom: 8px; padding-left: 2px; }
.icon-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(68px, 1fr)); gap: 6px; }
.icon-item { display: flex; flex-direction: column; align-items: center; gap: 3px; padding: 8px 4px; border: 1px solid #e8ecf1; border-radius: 4px; cursor: pointer; transition: all 0.15s; }
.icon-item:hover { border-color: #10b981; background: #ecfdf5; }
.icon-item.selected { border-color: #10b981; background: #dcfce7; }
.icon-item i { font-size: 18px; color: #374151; }
.icon-item.selected i { color: #059669; }
.icon-name { font-size: 9px; color: #9ca3af; text-align: center; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%; }
.no-icons { text-align: center; padding: 30px; color: #9ca3af; font-size: 13px; }
.icon-preview { flex: 1; display: flex; align-items: center; gap: 6px; font-size: 14px; color: #374151; }
.icon-preview i { font-size: 18px; color: #10b981; }
</style>
